import React, { useState, useEffect } from "react";
import QuestionTitle from "../QuestionTitle";
import TestImageImg from "../../../../../assets/images/joftPooch/pictureTestImg.jpg";
import RangeSlider from "./RangeSlider";
import { useSelector, useDispatch } from "react-redux";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";
import SingularSlider from "./SingularSlider";
import CustomHint from "../../../../../assets/containers/CustomHint";

export default function RangeQuestion() {
  const dispatch = useDispatch();
  const { currentQuestion, rightAnswer } = useSelector(({ quiz }) => quiz);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setmaxValue] = useState(0);

  useEffect(() => {
    if (currentQuestion) {
      setMinValue(currentQuestion.minRange);
      setmaxValue(currentQuestion.maxRange);
    }
  }, [currentQuestion]);

  useEffect(() => {
    setMinValue(minValue);
    setmaxValue(maxValue);
  }, [minValue, maxValue]);

  useEffect(() => {
    if (currentQuestion) {
      if (currentQuestion.minRangeAnswer === currentQuestion.maxRangeAnswer) {
        dispatch(
          setQuestionAnswer({
            questionId: currentQuestion._id,
            userMinRangeAnswer: maxValue,
            userMaxRangeAnswer: maxValue,
          })
        );
      } else {
        dispatch(
          setQuestionAnswer({
            questionId: currentQuestion._id,
            userMinRangeAnswer: minValue,
            userMaxRangeAnswer: maxValue,
          })
        );
      }
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [minValue, maxValue, currentQuestion]);

  return (
    <div className="w-100">
      {rightAnswer && (
        <div className="my-5">
          <CustomHint hint={`پاسخ صحیح: ${rightAnswer}`} />
        </div>
      )}
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? `${baseURL}file/get/${currentQuestion.cover}`
                : TestImageImg
              : TestImageImg
            : TestImageImg
        }
      />

      {currentQuestion &&
        (currentQuestion.minRangeAnswer === currentQuestion.maxRangeAnswer ? (
          <SingularSlider
            min={currentQuestion?.minRange}
            max={currentQuestion?.maxRange}
            value={maxValue}
            stepSize={currentQuestion?.stepSizeRange}
            setValue={(val) => setmaxValue(val)}
          />
        ) : (
          <RangeSlider
            qId={currentQuestion._id}
            min={currentQuestion?.minRange}
            max={currentQuestion?.maxRange}
            stepSize={currentQuestion?.stepSizeRange}
            setMin={(min) => setMinValue(min)}
            setMax={(max) => setmaxValue(max)}
          />
        ))}
    </div>
  );
}
